module.exports = __webpack_public_path__ + "img/icons8-crown-96.5e6e142d.png";